import * as brandColors from '../../../../utils/brand-colors';

export default (theme) => ({
  catagoryTitle: {
    margin: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  dashboardItem: {
    padding: `${theme.spacing(2)}px 0`,
    borderTop: `1px solid ${brandColors.grey[100]}`,
  },
  statusBadge: { margin: 5 },
  tagDivider: { margin: theme.spacing(1) },
  sectionDivider: { marginBottom: theme.spacing(1) },
});
